<ng-container *ngIf="relation; else loading">
    <div class="passport-info">
        <div class="passport-info__avatar" [class.open]="isDetailsVisible" (click)="onToggle()">
            <div class="passport-info__icon">
                <wuc-icon
                    type="secondary"
                    icon="profile-picture"
                    [size]="(isScreenSmall$ | async) ? 'l' : 'xxl'"
                ></wuc-icon>
                <strong>{{ relation.name }}</strong>
            </div>
            <div class="passport-info__toggle">
                <wuc-icon-ui icon="arrow-up-bold" *ngIf="isDetailsVisible"></wuc-icon-ui>
                <wuc-icon-ui icon="arrow-down-bold" *ngIf="!isDetailsVisible"></wuc-icon-ui>
            </div>
        </div>
        <wuc-balloon
            [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'leftTop'"
            backgroundStyle="tertiary"
            padding="large"
            class="passport-info__details"
            [class.passport-info__details--show]="isDetailsVisible"
            [class.passport-info__details--hide]="!isDetailsVisible"
        >
            <wuc-list>
                <wuc-list-item>
                    <strong>Adres:</strong>
                    {{ relation.residential_address.address.street_name }}
                    {{ relation.residential_address.civic_number }}
                    {{ relation.residential_address.civic_number_suffix }}
                    {{ relation.residential_address.postal_code }}
                    {{ relation.residential_address.address.city | capitalize }}
                </wuc-list-item>
                <wuc-list-item>
                    <strong>Polis/klantnummer</strong>
                    : {{ relation.relation_id }}
                </wuc-list-item>
                <wuc-list-item>
                    <strong>Gezinssamenstelling:</strong>
                    {{ relation.family_composition.family_composition_description }}
                </wuc-list-item>
            </wuc-list>
            <br />
            <div class="passport-info__details-link">
                <wuc-link type="secondary" route="/mijn-verzekeringsmap/mijn-gegevens">Gegevens wijzigen</wuc-link>
            </div>
        </wuc-balloon>
    </div>
</ng-container>

<ng-template #loading>
    <div class="passport-info">
        <div class="passport-info__avatar">
            <div class="passport-info__icon">
                <wuc-skeleton shape="circle" height="6rem" width="6rem"></wuc-skeleton>
                <wuc-skeleton height="1.6rem" width="12rem"></wuc-skeleton>
            </div>
            <div class="passport-info__toggle">
                <wuc-skeleton shape="circle" height="1.6rem" width="1.6rem"></wuc-skeleton>
            </div>
        </div>
        <wuc-balloon
            [arrowPosition]="(isScreenSmall$ | async) ? 'topLeft' : 'leftTop'"
            backgroundStyle="tertiary"
            padding="large"
            class="passport-info__details"
            [class.passport-info__details--show]="isDetailsVisible"
            [class.passport-info__details--hide]="!isDetailsVisible"
        >
            <wuc-list [expanded]="true">
                <wuc-list-item>
                    <wuc-skeleton height="1.6rem" width="34.5rem"></wuc-skeleton>
                </wuc-list-item>
                <wuc-list-item>
                    <wuc-skeleton height="1.6rem" width="34.5rem"></wuc-skeleton>
                </wuc-list-item>
                <wuc-list-item>
                    <wuc-skeleton height="1.6rem" width="34.5rem"></wuc-skeleton>
                </wuc-list-item>
            </wuc-list>
            <br />
            <div class="passport-info__details-link">
                <wuc-skeleton height="1.6rem" width="12.5rem"></wuc-skeleton>
            </div>
        </wuc-balloon>
    </div>
</ng-template>
